import { Injectable } from '@angular/core';

import { AutoRedirectRule } from '../../models/auto-redirect-rule';

import { BackendBaseService } from '../backend-base.service';
import { HttpClientService } from '../common/http-client.service';

@Injectable({
  providedIn: 'root',
})
export class AutoRedirectRuleService extends BackendBaseService {
  url: string = 'auto_redirect_rules';

  constructor(public httpClient: HttpClientService) {
    super(httpClient);
  }

  save(autoRedirectRule: AutoRedirectRule): Promise<any> {
    return super.save({
      id: autoRedirectRule.id,
      auto_redirect_rule: autoRedirectRule
    });
  }
}
